
import { Vue, Component, Ref } from 'vue-property-decorator';
import { BrandService } from '@/services/brand_service';
import lazyInject from '@/di';
import LogDetailDrawer from './components/LogDetailDrawer.vue';

@Component({
  components: {
    LogDetailDrawer,
  },
})
export default class BrandAlbumLog extends Vue {
  @lazyInject(BrandService)
  protected brandService!: BrandService;

  @Ref('logDetailDrawer')
  logDetailDrawer!: LogDetailDrawer;

  columns = [
    {
      title: '模板ID',
      dataIndex: 'operate_id',
      align: 'center',
      width: '200px',
      scopedSlots: { customRender: 'operate_id' },
    },
    {
      title: '操作人名称',
      dataIndex: 'operate_name',
      align: 'center',
      width: '200px',
      scopedSlots: { customRender: 'operate_name' },
    },
    {
      title: '操作时间',
      dataIndex: 'operate_time',
      align: 'center',
      width: '200px',
      scopedSlots: { customRender: 'operate_time' },
    },
    {
      title: '日志内容',
      dataIndex: 'desc',
      align: 'center',

      scopedSlots: { customRender: 'desc' },
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      width: '200px',
      scopedSlots: { customRender: 'action' },
    },
  ];
  // "object_id": "11", --模板ID
  // "desc": "编辑相册模板：第四套模板", --日志内容
  // "operate_id": 24188, --操作人ID
  // "operate_name": "15010066920", --操作人名称
  // "status": 1, --状态：1 - 成功，2 - 失败
  // "operate_type": "edit", --操作分类，除 edit 外，其他都是 ''
  // "operate_time": "2025-11-27 17:36:17" -- 操作时间

  data = [];

  formDAta: any = {};

  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
    onChange: this.onChange,
    showTotal: (total: any) => `共 ${total} 条`,
  };


  onChange(page: number) {
    this.pagination.current = page;
    this.formDAta.page = page;
    this.getLog(this.formDAta);
  }

  onShowSizeChange(current: number, size: number) {
    this.pagination.current = current;
    this.pagination.pageSize = size;
    this.formDAta.page = current;
    this.formDAta.pageSize = size;
    this.getLog(this.formDAta);
  }


  mounted() {
    const { templateId } = this.$route.params;
    this.formDAta = {
      template_id: templateId,
      page: 1,
      pageSize: this.pagination.pageSize,
    };
    this.getLog(this.formDAta);
  }

  refresh() {
    this.formDAta = {
      template_id: this.$route.params.templateId,
      page: 1,
      pageSize: this.pagination.pageSize,
    };
    this.pagination.current = 1;
    this.getLog(this.formDAta);
  }

  async getLog(data: any) {
    try {
      const res = await this.brandService.brandAlbumKaTemplateLog(data);
      console.log(res);
      this.data = res.list;
      this.pagination.total = res.total;
    } catch (error) {
      // this.$message.error('获取日志失败');
    }
  }

  lookDetail(val: any) {
    this.logDetailDrawer.init(val);
  }
}
